import request from '@/utils/request';

// export function fetchStatic(file_path) {
//   return request({
//     url: '/api/base/feishu-callback',
//     method: 'get',
//     params: {
//       open_id
//     }
//   });
// }

export function toLogin({ open_id, code, status }) {
  return request({
    url: '/api/base/feishu-callback',
    method: 'get',
    params: {
      open_id,
      code,
      status
    }
  });
}

/**
 * 退出登录
 */
export function logoutApi() {
  return request({
    url: '/api/base/logout',
    method: 'get'
  });
}

/**
 * 获取飞书用户信息
 */
export function getUserInfoFeishu() {
  return request({
    url: '/api/base/user-info',
    method: 'get'
  });
}

/**
 * 
 * 获取用户信息
 */
export function getUserInfo() {
  return request({
    url: '/api/base/user',
    method: 'get'
  });
}

/**
 * 获取没有登录的用户信息
 * @returns 
 */
export function getNologinUsers() {
  return request({
    url: '/api/base/nologin-users',
    method: 'get'
  });
}



// TODO:以上是新的

/**
 * login
 */
export function LoginApi(data) {
  return request({
    url: '/api/base/login',
    method: 'post',
    data
  });
}

/**
 * 获取图形校验码
 */
export function getImgCode() {
  return request({
    url: '/api/base/img',
    method: 'get'
  });
}
